import {FC} from "react";

interface IProps {}

export const PrivacyImage: FC<IProps> = ({}: IProps) => {
    return (
        <img src="static/privacy-image.svg" alt="privacy-image" />
       
    );
};
